import React, { useEffect, useState } from "react";
import "./Cart.css";

function Cart({ cart, setCart }) {
    const [price, setPrice] = useState(0);

    const handleRemove = (id) => {
        const arr = cart.filter((item) => item.id !== id);
        setCart(arr);
        handlePrice();
    };

    const handlePrice = () => {
        let ans = 0;
        cart.map((item) => (ans += item.price));
        setPrice(ans);
    };

    useEffect(() => {
        handlePrice();
    });


  console.log("cart page", cart);
  return (
    <div className="cartmain">
      <article>
        {cart.map((item) => (
          <div className="cartbox" key={item.id}>
            <div className="cartimg">
              <img src={item.image} alt="empty" />
              <p>{item.model}</p>
            </div>
            {/* <div>
                <button className="btn btn-success" onClick={()=> handleChange(item, 1)}>+</button>
                <button></button>
                <button className="btn btn-primary" onClick={()=> handleChange(item, -1)}>-</button>
            </div> */}
                            <span className="pricecart">{item.price}</span>

            <div>
                <button className="btn btn-danger removebtn" onClick={() => handleRemove(item.id)}>Remove</button>
            </div>
            <hr/>
          </div>
          
        ))}
        <div className="total">
            <span className="totaltext">Total Price</span>
            <span>Rs - &nbsp; <span style={{color:"red", fontSize:"30px"}}>{price}</span></span>
        </div>
      </article>
    </div>
  );
}

export default Cart;
